App.SmProgressComponent = Em.Component.extend
  classNames: [ 'sm-progress' ]
  value: 0

  style: Ember.computed 'value', ->
    new Ember.Handlebars.SafeString "width: #{@get 'value'}%"
